<span class="example-pizza-party" matSnackBarLabel>
    Pizza party!!!
  </span>
  <span matSnackBarActions>
    <button mat-button matSnackBarAction >🍕</button>
  </span>
  
  